export default __webpack_public_path__ + "static/twinkle-f7f1c71e27abb78571afa6ee203a65cf.mp3";